import React from "react";
import NoteItem from "./NoteItem";
import { showFormattedDate } from "../utils/index";

function NoteListArchive({ notes, onDelete, onArchive }) {
  if (notes.length > 0) {
    return (
      <div className="notes-list">
        {notes.map((note) => {
          return (
            <NoteItem
              key={note.id}
              id={note.id}
              date={showFormattedDate(note.createdAt)}
              onDelete={onDelete}
              onArchive={onArchive}
              archive={"Pindahkan"}
              {...note}
            />
          );
        })}
      </div>
    );
  }

  return <div className="notes-list__empty-message">Tidak ada catatan</div>;
}

export default NoteListArchive;
